import styled from 'styled-components/macro';
import { UnderlineContainerText as UnderlineContainerTextOriginal } from 'components/UnderlineContainer';

export const UnderlineContainerText = styled(UnderlineContainerTextOriginal)`
  display: block;
`;
